module.exports = __webpack_public_path__ + "img/logo.013261f1.png";